<template>
  <v-container>
    <current-user-can permission="editPermissions">
      <v-card>
        <v-card-title>
          Roles
          <v-btn x-small @click="newRoleDialog = true">Add Role</v-btn>
          <v-btn x-small @click="newPermissionDialog = true">
            Add Permission
          </v-btn>
        </v-card-title>
        <v-container>
          <v-text-field
            v-model="searchText"
            label="filter permissions"
            single-line
            hide-details
          ></v-text-field>
        </v-container>
        <v-dialog card v-model="newRoleDialog" max-width="30em">
          <v-card>
            <v-card-title> Add a role </v-card-title>
            <v-container fluid>
              <v-text-field
                label="Name"
                :value="newRoleName"
                @input="setRoleName"
                hint="no uppercase letters or spaces allowed"
                persistent-hint
                :message="newRoleError"
              ></v-text-field>
              <v-textarea
                label="Description"
                v-model="newRoleDescription"
                rows="2"
                auto-grow
              ></v-textarea>
              <v-btn @click="createRole" :loading="loading.newRole"
                >Create</v-btn
              >
            </v-container>
          </v-card>
        </v-dialog>
        <v-dialog card v-model="newPermissionDialog" max-width="30em">
          <v-card>
            <v-card-title> Add a Permission </v-card-title>
            <v-container fluid>
              <v-text-field
                label="Name"
                :value="newPermissionName"
                @input="newPermissionName = $event.trim().replace(/\W/g, '')"
                hint="no spaces allowed"
                persistent-hint
                :message="newPermissionError"
              ></v-text-field>
              <v-btn @click="createPermission" :loading="loading.newPermission"
                >Create</v-btn
              >
            </v-container>
          </v-card>
        </v-dialog>

        {{ error }}
        <v-data-table
          :message="error"
          :items="permissionRoles"
          :headers="columnHeaders"
          :loading="loading.all"
          dense
          :items-per-page="20"
          sort-by="role"
          sort-desc
          single-select
          :search="searchText"
        >
          <template v-slot:item="{ item }">
            <tr>
              <th>{{ item.name }}</th>
              <td
                v-for="col of roles"
                :key="`checkbox-${item.name}-${col.name}`"
              >
                <v-progress-circular
                  indeterminate
                  v-if="loading[`${col.name}-${item.name}`]"
                />
                <v-simple-checkbox
                  :value="item[col.name]"
                  @input="updatePermission(item.name, col.name)"
                  v-else
                  :size="8"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </current-user-can>
  </v-container>
</template>

<script>
export default {
  name: "AdminRoles",
  data() {
    return {
      roles: [],
      permissionOptions: [],
      loading: {
        all: false,
        newRole: false,
      },
      error: "",
      newRoleDialog: false,
      newRoleName: "",
      newRoleDescription: "",
      newRoleError: "",
      newPermissionDialog: false,
      newPermissionName: "",
      newPermissionDescription: "",
      newPermissionError: "",
      searchText: "",
    };
  },
  async created() {
    try {
      this.loading.all = true;
      await this.getRoles();
      await this.getPermissions();
    } catch (e) {
      this.error = e;
    } finally {
      this.loading.all = false;
    }
  },
  computed: {
    columnHeaders() {
      let heads =
        this.roles.map((r) => {
          return {
            text: r.name,
            value: r.name,
            align: "center",
            sortable: false,
          };
        }) || [];
      return [
        { text: "Permission", value: "name", width: "20em", sorted: "desc" },
        ...heads,
      ];
    },
    dynamicPermissionOptions() {
      return this.roles.map((r) => r.permissions.map((p) => p.permission));
    },
    permissionRoles() {
      return this.permissionOptions.map(({ name }) => {
        const permissionRow = {
          name: name,
        };
        for (const role of this.roles) {
          if (
            role.permissions.length &&
            role.permissions.find((p) => p.permission === name)
          ) {
            permissionRow[role.name] = true;
          } else {
            permissionRow[role.name] = false;
          }
        }
        return permissionRow;
      });
    },
    // rolePermissions() {
    //   return this.roles.map((r) => {
    //     let roleName = r.name.startsWith("S-1")
    //       ? `(MSTeam) ${r.description}`
    //       : r.name;
    //     let obj = { role: roleName, roleId: r.id };
    //     this.permissionOptions.forEach(
    //       (po) =>
    //         (obj[po.name] = !!r.permissions
    //           .map((p) => p.permission)
    //           .includes(po.name))
    //     );
    //     return obj;
    //   });
    // },
  },
  methods: {
    async getPermissions() {
      let permOptions = await this.$http.get("marcopermissionoptions");
      this.permissionOptions = [...permOptions.data];
    },
    async getRoles() {
      let roles = await this.$http.get("roles", {
        params: {
          filter: {
            include: "permissions",
            where: { name: { nlike: "s-1%" } },
          },
        },
      });
      this.roles = [...roles.data];
    },
    async updatePermission(PermName, RoleName) {
      try {
        this.$set(this.loading, RoleName + "-" + PermName, true);
        let role = this.roles.find((r) => r.name === RoleName);
        const roleId = role.id;
        let rolePerm = role.permissions.find(
          (rp) => rp.permission === PermName
        );
        if (!rolePerm) {
          console.log("adding permissions: ", PermName, role);
          await this.$http.post(`roles/${roleId}/permissions`, {
            name: PermName,
            permission: PermName,
          });
        } else {
          console.log("removing permissions: ", PermName, role);
          await this.$http.delete(`roles/${roleId}/permissions/${rolePerm.id}`);
        }
        await this.getRoles();
      } catch (e) {
        console.error("error removing permission: ", e);
      } finally {
        this.$set(this.loading, RoleName + "-" + PermName, false);
      }
    },
    setRoleName(name) {
      this.newRoleName = name.trim().toLowerCase().replace(/\W/g, "_");
    },
    async createRole() {
      try {
        this.loading.newRole = true;
        if (!this.newRoleName) {
          return false;
        }
        await this.$http.post("roles", {
          name: this.newRoleName,
          description: this.newRoleDescription,
        });

        this.newRoleDialog = false;
        this.newRoleName = "";
        this.newRoleDescription = "";
        this.newRoleError = "";
      } catch (e) {
        this.newRoleError = e.message;
      } finally {
        this.loading.newRole = false;
        await this.getRoles();
      }
    },
    async createPermission() {
      try {
        this.loading.newPermission = true;
        if (!this.newPermissionName) {
          return false;
        }
        await this.$http.post("marcopermissionoptions", {
          name: this.newPermissionName,
        });

        this.newPermissionDialog = false;
        this.newPermissionName = "";
        this.newPermissionDescription = "";
        this.newPermissionError = "";
      } catch (e) {
        this.newPermissionError = e.message;
      } finally {
        this.loading.newPermission = false;
        await this.getPermissions();
      }
    },
  },
};
</script>
